import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchNutritionPlanByIdArgs,
  FetchNutritionPlansArgs,
} from '../api/types/nutritionPlans.types';

import {
  fetchNutritionPlanById,
  fetchNutritionPlans,
} from '../api/nutritionPlans.api';

export const nutritionPlansQueryKeys = createQueryKeys('nutritionPlans', {
  fetchInfiniteNutritionPlans: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
  }: FetchNutritionPlansArgs) => ({
    queryFn: (context?: { pageParam?: unknown }) =>
      fetchNutritionPlans({
        contentFilters,
        locale,
        organizationId,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      }),
    queryKey: [organizationId, contentFilters, tableFilters],
  }),
  fetchNutritionPlanById: ({
    id,
    locale,
    organizationId,
  }: FetchNutritionPlanByIdArgs) => ({
    queryFn: () => fetchNutritionPlanById({ id, locale, organizationId }),
    queryKey: [id, organizationId, locale],
  }),
});
